<div
  class="w-max capitalize text-b2 px-[16px] py-[6px] duration-300 transition-all rounded-[16px] cursor-pointer select-none whitespace-nowrap"
  [ngClass]="ButtonStyle"
>
  {{ title }}
</div>
